import { useRef, useEffect } from 'react'

/**
 * Like componentDidUpdate - fires on update, but not mount
 *
 * @export
 * @param {() => void} fn
 */
export function useDidUpdate(fn: () => void, deps: any[] = []) {
  const firstRunRef = useRef(true)

  useEffect(() => {
    if (firstRunRef.current) {
      firstRunRef.current = false
    } else {
      fn()
    }
  }, deps)
}
